
import React, { useState } from 'react';
import Header from './components/Header';
import ProgressBar from './components/ProgressBar';
import Step1LeiterForm from './components/Step1LeiterForm';
import Step2ParticipantsForm from './components/Step2ParticipantsForm';
import Step3Confirmation from './components/Step3Confirmation';
import { Leiter, Participant } from '../types';
import Footer from "../components/Footer.tsx";
import './App.css';

const App: React.FC = () => {
    const [currentStep, setCurrentStep] = useState<number>(1);
    const [leiterData, setLeiterData] = useState<Leiter | null>(null);
    const [participantsData, setParticipantsData] = useState<Participant[]>([]);

    const handleLeiterSubmit = (data: Leiter) => {
        setLeiterData(data);
        setCurrentStep(2);
    };

    const handleParticipantsSubmit = (participants: Participant[]) => {
        setParticipantsData(participants);
        setCurrentStep(3);
    };

    const handleBackFromParticipants = (currentParticipants: Participant[]) => {
        setParticipantsData(currentParticipants);
        setCurrentStep(prev => prev - 1);
    };

    const renderStep = () => {
        switch (currentStep) {
            case 1:
                return <Step1LeiterForm onSubmit={handleLeiterSubmit} initialData={leiterData} />;
            case 2:
                return <Step2ParticipantsForm
                            leiterData={leiterData!}
                            onSubmit={handleParticipantsSubmit}
                            onBack={handleBackFromParticipants}
                            initialData={participantsData}
                        />;
            case 3:
                return <Step3Confirmation />;
            default:
                return <Step1LeiterForm onSubmit={handleLeiterSubmit} initialData={leiterData} />;
        }
    };
    
    return (
        <div className="app-container">
            <Header />
            <main className="flex-grow container mx-auto p-4 md:p-8">
                <div className="max-w-4xl mx-auto mb-8">
                    <ProgressBar currentStep={currentStep} />
                </div>
                {renderStep()}
            </main>
            <Footer />
        </div>
    );
};

export default App;